/**
 * "Session lost" signal from the API layer to the app. `api.ts` emits it when
 * a refresh fails with 401; `App.tsx` turns it into the re-login dialog.
 * Kept separate so `api.ts` does not import the Redux store.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

export function onSessionExpired(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitSessionExpired(): void {
  listeners.forEach((listener) => listener());
}
